import Cell from './Cell'
import type { JInputData } from '~/models/report/jInputData'
import { type JStep, StepType } from '~/models/documents/jStep'

export class TextCell extends Cell {
  constructor(
    rowIndex: number,
    colIndex: number,
    inputs: JInputData[],
    step: JStep,
    isHistory: boolean,
    onExport: false,
    report_id: null,
  ) {
    if (step.type !== StepType.Text) throw new Error('Type mismatch')

    super(rowIndex, colIndex, inputs, step, isHistory, onExport, report_id)
  }

  get latestValue(): string {
    let value = super.latestValue

    if (this._step.separatorDecimal === ',')
      value = `${value}`.replace('.', ',')

    return value
  }

  get latestValueAsHtml(): string {
    return `<p>${this.latestValue?.replaceAll('\n', '<br />') ?? ''}</p>`
  }
}

export default TextCell
